import React, { useContext } from 'react';
import { UserContext } from '../context/UserContext';
import { ROLES } from '../config/constants';
import UserProfile from './Pet Owner/Profile';

const Profile = () => {
  const { roles } = useContext(UserContext); // Get the roles from context

  return (
    <div className="p-6 space-y-6">
      {/* {roles.includes(ROLES.ADMIN) && (

        <AdminProfile />
      )} */}

      {roles.includes(ROLES.USER) && (

        <UserProfile />
      )}

    

    </div>
  );
};

export default Profile;
